/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from '@mui/material/Grid'

// Soft UI Dashboard PRO React components
import SoftBox from 'components/SoftBox'

// Settings page components
import DashboardLayout from 'components/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'components/Navbars/DashboardNavbar'
import Sidenav from './components/Sidenav'
import BasicInfo from './components/BasicInfo'
import EmploymentDetails from './components/EmploymentDetails'
import PayStubDetails from './components/PayStubDetails'
import MilitaryDetails from './components/MilitaryDetails'
import Deductions from './components/Deductions'
import SocialSecurity from './components/SocialSecurity'
import LifeInsurance from './components/LifeInsurance'
import { useMediaQuery } from '@mui/material'

import { useRef, useEffect } from 'react'
import Tsp from './components/Tsp'
import Family from './components/Family'
import Healthcare from './components/Healthcare'
import Retirement from './components/Retirement'
import Other from './components/Other'

function Profile() {
  const isMobile = useMediaQuery('(max-width:1200px)')

  const containerRef = useRef()
  const sidenavRef = useRef()

  const resizeTimeoutRef = useRef(null)

  useEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
      if (resizeTimeoutRef.current) {
        clearTimeout(resizeTimeoutRef.current)
      }

      resizeTimeoutRef.current = setTimeout(() => {
        // console.log('OBSERVED CHANGE')
        if (sidenavRef.current) {
          sidenavRef.current.updateTabLocations()
        }
      }, 1000)
    })

    if (containerRef.current) {
      resizeObserver.observe(containerRef.current)
    }

    return () => {
      if (containerRef.current) {
        resizeObserver.unobserve(containerRef.current)
      }

      if (resizeTimeoutRef.current) {
        clearTimeout(resizeTimeoutRef.current)
      }
    }
  }, [])
  return (
    <DashboardLayout>
      <DashboardNavbar id={'navbar'} />
      <SoftBox p={{ xs: 1, lg: 3 }}>
        <Grid container ref={containerRef} spacing={{ xs: 1, lg: 3 }}>
          <Grid
            sx={{ backgroundColor: '#f8f9fa' }}
            position={'sticky'}
            top={75}
            zIndex={5}
            pb={2}
            item
            xs={12}
            xl={3}
          >
            <Sidenav ref={sidenavRef} isMobile={isMobile} />
          </Grid>

          <Grid item xs={12} xl={9} margin="auto">
            <SoftBox>
              <Grid container spacing={{ xs: 1, lg: 3 }}>
                {/* <Grid item xs={12}>
                  <Header />
                </Grid> */}
                <Grid
                  sx={{ scrollMarginTop: 75 }}
                  className={'settings-tab'}
                  id={'basic-info'}
                  item
                  xs={12}
                >
                  <BasicInfo />
                </Grid>
                <Grid
                  sx={{ scrollMarginTop: 75 }}
                  className={'settings-tab'}
                  id={'employment'}
                  item
                  xs={12}
                >
                  <EmploymentDetails />
                </Grid>
                <Grid
                  sx={{ scrollMarginTop: 75 }}
                  className={'settings-tab'}
                  id={'military'}
                  item
                  xs={12}
                >
                  <MilitaryDetails />
                </Grid>
                <Grid
                  sx={{ scrollMarginTop: 75 }}
                  className={'settings-tab'}
                  id={'family'}
                  item
                  xs={12}
                >
                  <Family />
                </Grid>
                <Grid
                  sx={{ scrollMarginTop: 75 }}
                  className={'settings-tab'}
                  id={'paystub'}
                  item
                  xs={12}
                >
                  <PayStubDetails />
                </Grid>
                <Grid
                  sx={{ scrollMarginTop: 75 }}
                  className={'settings-tab'}
                  id={'deductions'}
                  item
                  xs={12}
                >
                  <Deductions />
                </Grid>
                <Grid
                  sx={{ scrollMarginTop: 75 }}
                  className={'settings-tab'}
                  id={'healthcare'}
                  item
                  xs={12}
                >
                  <Healthcare />
                </Grid>
                <Grid
                  sx={{ scrollMarginTop: 75 }}
                  className={'settings-tab'}
                  id={'lifeinsurance'}
                  item
                  xs={12}
                >
                  <LifeInsurance />
                </Grid>
                <Grid
                  sx={{ scrollMarginTop: 75 }}
                  className={'settings-tab'}
                  id={'retirement'}
                  item
                  xs={12}
                >
                  <Retirement />
                </Grid>
                <Grid
                  sx={{ scrollMarginTop: 75 }}
                  className={'settings-tab'}
                  id={'tsp'}
                  item
                  xs={12}
                >
                  <Tsp />
                </Grid>
                <Grid
                  sx={{ scrollMarginTop: 75 }}
                  className={'settings-tab'}
                  id={'socialsecurity'}
                  item
                  xs={12}
                >
                  <SocialSecurity />
                </Grid>
                <Grid
                  sx={{ scrollMarginTop: 75 }}
                  className={'settings-tab'}
                  id={'other'}
                  item
                  xs={12}
                >
                  <Other />
                </Grid>
              </Grid>
            </SoftBox>
          </Grid>
        </Grid>
      </SoftBox>
      {/* <Footer /> */}
    </DashboardLayout>
  )
}

export default Profile
